import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Code2, Smartphone, Cloud, Shield, Zap, BarChart3, Palette, Globe } from "lucide-react";
import { cn } from "@/lib/utils";
const features = [
    {
        icon: Code2,
        title: "Clean Architecture",
        description: "Well-structured, maintainable code that scales with your business needs.",
        className: "from-blue-500/10 to-blue-600/10",
    },
    {
        icon: Smartphone,
        title: "Responsive Design",
        description: "Pixel-perfect experiences across all devices, from mobile to desktop.",
        className: "from-purple-500/10 to-purple-600/10",
    },
    {
        icon: Cloud,
        title: "Cloud Native",
        description: "Built for the cloud with auto-scaling, high availability, and global distribution.",
        className: "from-cyan-500/10 to-cyan-600/10",
    },
    {
        icon: Shield,
        title: "Enterprise Security",
        description: "OWASP-compliant security practices to protect your data and users.",
        className: "from-green-500/10 to-green-600/10",
    },
    {
        icon: Zap,
        title: "Blazing Fast",
        description: "Optimized performance with sub-second load times and instant interactions.",
        className: "from-yellow-500/10 to-yellow-600/10",
    },
    {
        icon: BarChart3,
        title: "Analytics Built-in",
        description: "Track user behavior and measure success with integrated analytics.",
        className: "from-orange-500/10 to-orange-600/10",
    },
    {
        icon: Palette,
        title: "Modern UI/UX",
        description: "Beautiful, intuitive interfaces designed for conversion and engagement.",
        className: "from-pink-500/10 to-pink-600/10",
    },
    {
        icon: Globe,
        title: "Global Reach",
        description: "Content delivery across 200+ cities worldwide for lightning-fast access.",
        className: "from-indigo-500/10 to-indigo-600/10",
    },
];
export function Features({ title = "Why choose us", subtitle = "We combine technical excellence with creative design to deliver solutions that drive results.", showHeader = true, }) {
    return (_jsx("section", { className: "section-padding", children: _jsxs("div", { className: "container-page", children: [showHeader && (_jsxs("div", { className: "mx-auto max-w-2xl text-center", children: [_jsx("h2", { className: "text-3xl font-bold tracking-tight sm:text-4xl", children: title }), _jsx("p", { className: "mt-4 text-lg text-muted-foreground", children: subtitle })] })), _jsx("div", { className: "mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4", children: features.map((feature) => (_jsxs("div", { className: cn("group rounded-xl border bg-card p-6 transition-all hover:shadow-lg"), children: [_jsx("div", { className: cn("mb-4 inline-flex rounded-lg bg-gradient-to-br p-3", feature.className), children: _jsx(feature.icon, { className: "h-6 w-6" }) }), _jsx("h3", { className: "text-lg font-semibold", children: feature.title }), _jsx("p", { className: "mt-2 text-sm text-muted-foreground", children: feature.description })] }, feature.title))) })] }) }));
}
